import storeManager from '../store/StoreManager';
import sessionReader from '../store/readHelpers/SessionReader';
import settingsReader from '../store/readHelpers/SettingsReader';
import marketplacePropertiesService from './MarketplacePropertiesService';

function canSeeResultPage() {
    const { result, settings } = storeManager.getState();
    return !!result.metaData.isLoaded
        || (sessionReader.isContextExam() && settingsReader.hasSettingValue('qti2_hideResultpage', false, settings));
}

function canSeeSummaryPage() {
    const { result } = storeManager.getState();
    return !result.metaData.isLoaded || sessionReader.isOfflineMode();
}

// Only reliable after having used API GetUserResponses
function canSeeCorrectResponsesInDelivery() {
    const { result } = storeManager.getState();
    return result.metaData.isLoaded && !!result.metaData.hasAccessToCorrectResponses;
}

function canSeeScore() {
    const { result } = storeManager.getState();
    if (sessionReader.isContextViewOwnDelivery() && !(
        settingsReader.isShowResultsAndCorrectAnswersForStudentReviewEnabled() ||
        settingsReader.isShowMarksOnlySelectedForStudentReviewEnabled())) {
        return false;
    }
    return result.metaData.isLoaded && result.metaData.showScore;
}

function validateCandidateSubmissionAccessLevel(requiredLevel) {
    return !!marketplacePropertiesService.isSkipQuestionSubmissionReviewEnabled() &&
        !!sessionReader.isContextViewOwnDelivery() &&
        settingsReader.getSettingValue('candidate_submission_access_level') === requiredLevel;
}

const aclService = {
    canSeeResultPage,
    canSeeScore,
    canSeeSummaryPage,
    canSeeCorrectResponsesInDelivery,
    validateCandidateSubmissionAccessLevel,
};

export default aclService;
